const actions = {
  // DO_GET_RENT_VERIFICATIONS
  DO_GET_RENT_VERIFICATIONS: 'DO_GET_RENT_VERIFICATIONS',
  doGetRentVerifications: hash => ({
    type: actions.DO_GET_RENT_VERIFICATIONS,
    payload: hash,
  }),
  DO_GET_RENT_VERIFICATIONS_SUCCESS: 'DO_GET_RENT_VERIFICATIONS_SUCCESS',
  doGetRentVerificationsSuccess: response => ({
    type: actions.DO_GET_RENT_VERIFICATIONS_SUCCESS,
    payload: response
  }),
  DO_GET_RENT_VERIFICATIONS_FAILED: 'DO_GET_RENT_VERIFICATIONS_FAILED',
  doGetRentVerificationsFailed: response => ({
    type: actions.DO_GET_RENT_VERIFICATIONS_FAILED,
    payload: response
  }),
}

export default actions;


// WEBPACK FOOTER //
// ./src/redux/outstandingRentVerifications/actions.js